import { styled } from "@mui/material/styles";
import Select from "@mui/material/Select";

const StyledSelect = styled(Select, {
})(({ theme }) => ({
  "& .MuiSelect-outlined": {
    padding: "0px"
  },
  "& legend": {
    marginLeft: "-3px"
  },
  "&.MuiOutlinedInput-root": {
    fontSize: theme.typography["body1"]["fontSize"],
    fontWeight: "body1.fontWeight",
    backgroundColor: theme.palette["white_opacity"]["100"],
    color: theme.palette["black_opacity"]["100"],
    padding: "4px 8px",
    "& fieldset": {
      borderColor: theme.palette["black_opacity"]["30"],
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette["primary"]["60"],
    },
    "&.Mui-error fieldset": {
      borderColor: theme.palette["error"]["60"],
    },
    "&.Mui-disabled fieldset": {
      backgroundColor: theme.palette["black_opacity"]["05"],
      borderColor: theme.palette["black_opacity"]["30"],
    }
  },
  "& .MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: theme.palette["black_opacity"]["70"]
  },
  "& .MuiSelect-icon": {
    color: theme.palette["black_opacity"]["70"],
    "&.Mui-disabled": {
      color: theme.palette["black_opacity"]["70"],
    }
  }
}));

export default StyledSelect;